/**
 * Figma-style Collection Filter Interactions
 *
 * Features:
 * 1. Toggle/collapse the Dawn filter sidebar
 * 2. Custom Sort By dropdown
 * 3. Keeps working after Dawn AJAX facet updates
 * 4. Syncs custom dropdown with native Shopify select
 * 5. Keyboard accessible
 * 6. Prevents duplicate initialization
 */

(function () {
  'use strict';

  /* =========================================================
     CONFIG
  ========================================================= */

  var FILTER_BUTTON_ID = 'FigmaFilterToggleBtn';
  var FILTER_WRAPPER_SELECTOR = '#main-collection-filters';
  var FILTER_COLLAPSED_CLASS = 'filters-collapsed';

  /* =========================================================
     HELPERS
  ========================================================= */

  function getFilterButton() {
    return document.getElementById(FILTER_BUTTON_ID);
  }

  function getFilterWrapper() {
    return document.querySelector(FILTER_WRAPPER_SELECTOR);
  }

  function getCustomSelects() {
    return document.querySelectorAll(
      '.figma-custom-select select:not([data-figma-enhanced="true"])'
    );
  }

  /* =========================================================
     1. FILTER SIDEBAR TOGGLE
  ========================================================= */

  function toggleFilterSidebar(button) {
    var wrapper = getFilterWrapper();

    if (!wrapper || !button) {
      return;
    }

    var isCollapsed = wrapper.classList.toggle(FILTER_COLLAPSED_CLASS);

    button.setAttribute(
      'aria-expanded',
      isCollapsed ? 'false' : 'true'
    );

    button.classList.toggle(
      'is-collapsed',
      isCollapsed
    );
  }

  document.addEventListener('click', function (event) {
    var filterButton = event.target.closest(
      '#' + FILTER_BUTTON_ID
    );

    if (!filterButton) {
      return;
    }

    event.preventDefault();

    toggleFilterSidebar(filterButton);
  });

  /* =========================================================
     2. CUSTOM SORT DROPDOWN
  ========================================================= */

  function createCustomDropdown(selectElement) {
    if (!selectElement) {
      return;
    }

    if (selectElement.dataset.figmaEnhanced === 'true') {
      return;
    }

    var wrapper = selectElement.closest('.figma-custom-select');

    if (!wrapper) {
      return;
    }

    selectElement.dataset.figmaEnhanced = 'true';

    wrapper.classList.add('figma-select-wrapper');

    /*
     * Hide native select visually.
     * Keep it in DOM so Dawn/facets.js continues to work.
     */
    selectElement.classList.add(
      'figma-native-select-hidden'
    );

    /* ---------------------------------------------------------
       CREATE BUTTON
    --------------------------------------------------------- */

    var fakeButton = document.createElement('button');

    fakeButton.type = 'button';
    fakeButton.className = 'figma-select-button';

    fakeButton.setAttribute(
      'aria-haspopup',
      'listbox'
    );

    fakeButton.setAttribute(
      'aria-expanded',
      'false'
    );

    /*
     * Use a unique ID for aria-controls.
     */
    var listboxId =
      'figma-sort-listbox-' +
      Math.random()
        .toString(36)
        .substring(2, 10);

    fakeButton.setAttribute(
      'aria-controls',
      listboxId
    );

    /* ---------------------------------------------------------
       CURRENT OPTION
    --------------------------------------------------------- */

    var selectedOption =
      selectElement.options[
        selectElement.selectedIndex
      ];

    var selectedText = selectedOption
      ? selectedOption.textContent.trim()
      : '';

    fakeButton.innerHTML =
      '<span class="figma-select-button__label">' +
      escapeHtml(selectedText) +
      '</span>' +
      '<span class="figma-select-button__chevron" aria-hidden="true">' +
      '<svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span>';

    /* ---------------------------------------------------------
       CREATE LISTBOX
    --------------------------------------------------------- */

    var listbox = document.createElement('ul');

    listbox.className = 'figma-select-listbox';

    listbox.id = listboxId;

    listbox.setAttribute(
      'role',
      'listbox'
    );

    listbox.hidden = true;

    Array.prototype.forEach.call(
      selectElement.options,
      function (option, index) {
        var optionElement =
          document.createElement('li');

        optionElement.className =
          'figma-select-option';

        optionElement.setAttribute(
          'role',
          'option'
        );

        optionElement.setAttribute(
          'tabindex',
          '-1'
        );

        optionElement.dataset.value =
          option.value;

        optionElement.dataset.index =
          String(index);

        optionElement.textContent =
          option.textContent.trim();

        if (option.selected) {
          optionElement.classList.add(
            'is-selected'
          );

          optionElement.setAttribute(
            'aria-selected',
            'true'
          );
        } else {
          optionElement.setAttribute(
            'aria-selected',
            'false'
          );
        }

        listbox.appendChild(
          optionElement
        );
      }
    );

    wrapper.appendChild(fakeButton);
    wrapper.appendChild(listbox);
  }

  /* =========================================================
     ESCAPE HTML
  ========================================================= */

  function escapeHtml(value) {
    var div = document.createElement('div');

    div.textContent = value || '';

    return div.innerHTML;
  }

  /* =========================================================
     UPDATE CUSTOM DROPDOWN
  ========================================================= */

  function syncCustomDropdown(wrapper) {
    if (!wrapper) {
      return;
    }

    var selectElement =
      wrapper.querySelector('select');

    var fakeButton =
      wrapper.querySelector(
        '.figma-select-button'
      );

    var listbox =
      wrapper.querySelector(
        '.figma-select-listbox'
      );

    if (
      !selectElement ||
      !fakeButton ||
      !listbox
    ) {
      return;
    }

    var selectedOption =
      selectElement.options[
        selectElement.selectedIndex
      ];

    var label =
      fakeButton.querySelector(
        '.figma-select-button__label'
      );

    if (label) {
      label.textContent =
        selectedOption
          ? selectedOption.textContent.trim()
          : '';
    }

    listbox
      .querySelectorAll(
        '.figma-select-option'
      )
      .forEach(function (optionElement) {
        var isSelected =
          optionElement.dataset.value ===
          selectElement.value;

        optionElement.classList.toggle(
          'is-selected',
          isSelected
        );

        optionElement.setAttribute(
          'aria-selected',
          isSelected
            ? 'true'
            : 'false'
        );
      });
  }

  /* =========================================================
     CLOSE ALL DROPDOWNS
  ========================================================= */

  function closeAllDropdowns() {
    document
      .querySelectorAll(
        '.figma-select-listbox'
      )
      .forEach(function (listbox) {
        listbox.hidden = true;
      });

    document
      .querySelectorAll(
        '.figma-select-button'
      )
      .forEach(function (button) {
        button.setAttribute(
          'aria-expanded',
          'false'
        );

        button.classList.remove(
          'is-open'
        );
      });
  }

  /* =========================================================
     OPEN DROPDOWN
  ========================================================= */

  function openDropdown(button, listbox) {
    if (!button || !listbox) {
      return;
    }

    closeAllDropdowns();

    listbox.hidden = false;

    button.setAttribute(
      'aria-expanded',
      'true'
    );

    button.classList.add(
      'is-open'
    );
  }

  /* =========================================================
     BUTTON CLICK
  ========================================================= */

  document.addEventListener('click', function (event) {
    var button = event.target.closest(
      '.figma-select-button'
    );

    if (!button) {
      return;
    }

    event.preventDefault();

    var wrapper =
      button.closest(
        '.figma-select-wrapper'
      );

    if (!wrapper) {
      return;
    }

    var listbox =
      wrapper.querySelector(
        '.figma-select-listbox'
      );

    if (!listbox) {
      return;
    }

    var currentlyOpen =
      !listbox.hidden;

    if (currentlyOpen) {
      closeAllDropdowns();
    } else {
      openDropdown(
        button,
        listbox
      );
    }
  });

  /* =========================================================
     OPTION CLICK
  ========================================================= */

  document.addEventListener('click', function (event) {
    var optionElement =
      event.target.closest(
        '.figma-select-option'
      );

    if (!optionElement) {
      return;
    }

    event.preventDefault();

    var wrapper =
      optionElement.closest(
        '.figma-select-wrapper'
      );

    if (!wrapper) {
      return;
    }

    var selectElement =
      wrapper.querySelector('select');

    if (!selectElement) {
      return;
    }

    var newValue =
      optionElement.dataset.value;

    /*
     * Avoid unnecessary change events.
     */
    if (
      selectElement.value !==
      newValue
    ) {
      selectElement.value =
        newValue;

      /*
       * Important:
       * Dawn's facets.js listens for
       * the native change event.
       */
      selectElement.dispatchEvent(
        new Event(
          'change',
          {
            bubbles: true
          }
        )
      );
    }

    syncCustomDropdown(wrapper);

    closeAllDropdowns();
  });

  /* =========================================================
     CLICK OUTSIDE
  ========================================================= */

  document.addEventListener('click', function (event) {
    if (
      !event.target.closest(
        '.figma-select-wrapper'
      )
    ) {
      closeAllDropdowns();
    }
  });

  /* =========================================================
     KEYBOARD SUPPORT
  ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {
      /*
       * Escape closes dropdown.
       */
      if (event.key === 'Escape') {
        closeAllDropdowns();
        return;
      }

      var button =
        event.target.closest(
          '.figma-select-button'
        );

      if (!button) {
        return;
      }

      var wrapper =
        button.closest(
          '.figma-select-wrapper'
        );

      if (!wrapper) {
        return;
      }

      var listbox =
        wrapper.querySelector(
          '.figma-select-listbox'
        );

      if (!listbox) {
        return;
      }

      /*
       * Enter / Space
       */
      if (
        event.key === 'Enter' ||
        event.key === ' '
      ) {
        event.preventDefault();

        if (listbox.hidden) {
          openDropdown(
            button,
            listbox
          );
        } else {
          closeAllDropdowns();
        }

        return;
      }

      /*
       * Arrow Down
       */
      if (event.key === 'ArrowDown') {
        event.preventDefault();

        if (listbox.hidden) {
          openDropdown(
            button,
            listbox
          );
        }

        var firstOption =
          listbox.querySelector(
            '.figma-select-option'
          );

        if (firstOption) {
          firstOption.focus();
        }

        return;
      }

      /*
       * Arrow Up
       */
      if (event.key === 'ArrowUp') {
        event.preventDefault();

        if (listbox.hidden) {
          openDropdown(
            button,
            listbox
          );
        }

        var options =
          listbox.querySelectorAll(
            '.figma-select-option'
          );

        if (options.length) {
          options[
            options.length - 1
          ].focus();
        }
      }
    }
  );

  /* =========================================================
     LISTBOX KEYBOARD NAVIGATION
  ========================================================= */

  document.addEventListener(
    'keydown',
    function (event) {
      var optionElement =
        event.target.closest(
          '.figma-select-option'
        );

      if (!optionElement) {
        return;
      }

      var listbox =
        optionElement.closest(
          '.figma-select-listbox'
        );

      if (!listbox) {
        return;
      }

      var options =
        Array.prototype.slice.call(
          listbox.querySelectorAll(
            '.figma-select-option'
          )
        );

      var currentIndex =
        options.indexOf(
          optionElement
        );

      var nextIndex =
        currentIndex;

      if (event.key === 'ArrowDown') {
        event.preventDefault();

        nextIndex =
          Math.min(
            currentIndex + 1,
            options.length - 1
          );

        options[
          nextIndex
        ].focus();

        return;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();

        nextIndex =
          Math.max(
            currentIndex - 1,
            0
          );

        options[
          nextIndex
        ].focus();

        return;
      }

      if (
        event.key === 'Enter' ||
        event.key === ' '
      ) {
        event.preventDefault();

        optionElement.click();

        return;
      }

      if (event.key === 'Escape') {
        closeAllDropdowns();

        var button =
          listbox
            .closest(
              '.figma-select-wrapper'
            )
            ?.querySelector(
              '.figma-select-button'
            );

        if (button) {
          button.focus();
        }
      }
    }
  );

  /* =========================================================
     INITIALIZE DROPDOWNS
  ========================================================= */

  function initCustomDropdowns() {
    var selectElements =
      getCustomSelects();

    selectElements.forEach(
      createCustomDropdown
    );
  }

  /* =========================================================
     INITIALIZE ON PAGE LOAD
  ========================================================= */

  function init() {
    initCustomDropdowns();

    /*
     * Make sure filter button starts
     * in expanded state.
     */
    var filterButton =
      getFilterButton();

    var filterWrapper =
      getFilterWrapper();

    if (
      filterButton &&
      filterWrapper
    ) {
      var isCollapsed =
        filterWrapper.classList.contains(
          FILTER_COLLAPSED_CLASS
        );

      filterButton.setAttribute(
        'aria-expanded',
        isCollapsed
          ? 'false'
          : 'true'
      );

      filterButton.classList.toggle(
        'is-collapsed',
        isCollapsed
      );
    }
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  /* =========================================================
     7. OBSERVE DAWN AJAX DOM UPDATES
  ========================================================= */

  var observerTimeout = null;

  var observer =
    new MutationObserver(
      function (mutations) {
        var hasAddedNodes =
          mutations.some(
            function (mutation) {
              return (
                mutation.addedNodes &&
                mutation.addedNodes.length >
                  0
              );
            }
          );

        if (!hasAddedNodes) {
          return;
        }

        window.clearTimeout(
          observerTimeout
        );

        observerTimeout =
          window.setTimeout(
            function () {
              initCustomDropdowns();

              /*
               * Sync filter state after
               * Dawn replaces the facet DOM.
               */
              var filterButton =
                getFilterButton();

              var filterWrapper =
                getFilterWrapper();

              if (
                filterButton &&
                filterWrapper
              ) {
                var isCollapsed =
                  filterWrapper.classList.contains(
                    FILTER_COLLAPSED_CLASS
                  );

                filterButton.setAttribute(
                  'aria-expanded',
                  isCollapsed
                    ? 'false'
                    : 'true'
                );

                filterButton.classList.toggle(
                  'is-collapsed',
                  isCollapsed
                );
              }
            },
            100
          );
      }
    );

  if (document.body) {
    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }
})();